module.exports = __webpack_public_path__ + "static/media/ic-logout.2597cd0f.svg";